import CrownIcon from 'assets/Icons/CrownIcon';
import React from 'react';

import {
  borderB,
  borderColorClassName,
  borderL,
  borderT,
  headerHeight,
  typeMarginLeft,
} from '@/components/Subscription/PlanTable';
import Cell from '@/components/Subscription/PlanTable/Columns/Cell';
import H1Cell from '@/components/Subscription/PlanTable/Columns/H1Cell';
import H2Cell from '@/components/Subscription/PlanTable/Columns/H2Cell';
import CheckPoints from '@/components/Subscription/PlanTable/headerColumn/checkpoints';

const HeaderColumn = () => {
  return (
    <div className='flex-1 border-y border-transparent'>
      <div
        className='flex flex-col justify-between '
        style={{ height: headerHeight }}
      >
        <div className='flex flex-col gap-6'>
          <div className='flex flex-col gap-3'>
            <CrownIcon width={40} height={40} />
            <p className='text-2xl text-white'>Explore our plans</p>
          </div>
          <div>
            <CheckPoints />
          </div>
        </div>
        <p className='text-lg leading-[26px] text-white font-medium mb-3'>
          Details:
        </p>
      </div>

      <H1Cell
        className={`
                  ${borderColorClassName}
                  ${borderT}
                  ${borderB}
                  `}
        title='What is inside'
      />
      <H2Cell title='What you will get:' />
      <Cell
        style={{ marginLeft: typeMarginLeft }}
        className={`
            ${borderColorClassName}
            ${borderL}
            `}
        title='Digital Copy'
      />
      <Cell
        style={{ marginLeft: typeMarginLeft }}
        className={`
            ${borderColorClassName}
            ${borderL}
            `}
        title='Hard Copy'
      />

      <Cell
        className={`
          ${borderColorClassName}
          ${borderT}`}
        title='Duration'
      />
      <Cell title='Validity' />
      <Cell title='Free Shipping' />
      <Cell title='App Access' />
    </div>
  );
};

export default HeaderColumn;
